import { heroStats, heroPoints } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20abstract%20starry%20night%20sky%20with%20warm%20golden%20nebula%20clouds%2C%20glowing%20dust%20particles%2C%20deep%20dark%20background%20with%20soft%20film%20grain%2C%20elegant%20high%20contrast%20atmosphere%2C%20artistic%20digital%20painting&width=1600&height=1000&seq=starcinema-hero-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/85"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 pt-28 pb-16 md:pt-36 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-100 text-xs md:text-sm">
              <i className="ri-planet-line text-primary-300"></i>
              网站入口 · 最新地址 · 网址大全
            </span>
            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-background-50">
              星辰影院官网入口与
              <br className="hidden md:block" />
              最新地址导航
            </h1>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-background-200 max-w-xl">
              本站把星辰影院相关的<strong className="text-background-50 font-semibold">官网入口、最新地址、网址大全、首页入口、官方网址与永久入口</strong>集中整理，方便你按当前需要快速定位到合适的访问方式，并对照更新记录判断信息是否仍然有效。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#entry"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                查看入口总览
              </a>
              <a
                href="#directory"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/30 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
              >
                <i className="ri-layout-masonry-line"></i>
                浏览网址大全
              </a>
            </div>

            <div className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
              {heroStats.map((s) => (
                <div key={s.label} className="flex flex-col gap-1">
                  <div className="flex items-center gap-1.5 text-primary-300">
                    <i className={`${s.icon} text-base`}></i>
                    <span className="font-heading text-xl md:text-2xl font-bold text-background-50">{s.value}</span>
                  </div>
                  <span className="text-xs text-background-200/80">{s.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="animate-fade-up">
            <div className="relative w-full aspect-[4/5] sm:aspect-[5/4] lg:aspect-[4/5] rounded-lg overflow-hidden border border-background-50/15">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20golden%20vintage%20film%20projector%20beam%20in%20a%20dark%20theater%2C%20floating%20dust%20particles%2C%20cozy%20cinematic%20ambient%20light%2C%20artistic%20illustration%20with%20rich%20amber%20tones&width=1000&height=1200&seq=starcinema-side-01&orientation=portrait"
                alt="温暖的影院放映光束氛围图"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
              {heroPoints.map((p) => (
                <div key={p.title} className="rounded-lg bg-background-50/10 border border-background-50/15 p-3.5">
                  <div className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500/20 text-primary-200">
                    <i className={`${p.icon} text-base`}></i>
                  </div>
                  <h3 className="mt-2.5 text-sm font-semibold text-background-50">{p.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-background-200/85">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}